// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container */
.add-category-container {
  max-width: 520px;
  margin: 40px auto;
  padding: 30px;
  background: linear-gradient(180deg, #0f172a, #020617);
  border-radius: 20px;
  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.6);
  color: #ffffff;
  position: relative;
}

/* Heading */
.add-category-container h2 {
  text-align: center;
  margin-bottom: 25px;
  font-size: 22px;
  font-weight: 600;
}

/* Form */
.add-category-container form {
  display: flex;
  flex-direction: column;
}

/* Inputs */
.add-category-container input[type="text"],
.add-category-container input[type="file"] {
  width: 100%;
  padding: 12px 14px;
  margin-bottom: 18px;
  border-radius: 12px;
  border: 1px solid #1e293b;
  outline: none;
  transition: 0.3s;
}

.add-category-container input::placeholder {
  color: #64748b;
}

.add-category-container input:focus {
  border-color: #facc15;
  box-shadow: 0 0 0 2px rgba(250, 204, 21, 0.2);
}

/* Image Upload Box */
.image-upload-box {
  position: relative;
  width: 100%;
  height: 180px;
  border: 2px dashed #334155;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-bottom: 20px;
  background: #020617;
  transition: 0.3s;
  overflow: hidden;
}

.image-upload-box:hover {
  border-color: #facc15;
  background: #0f172a;
}

.image-upload-box span {
  color: #94a3b8;
  font-size: 14px;
}

.image-upload-box input[type="file"] {
  position: absolute;
  inset: 0;
  opacity: 0;
  cursor: pointer;
}

/* Preview Image */
.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 14px;
}

/* Button */
.add-category-container button:not(.close-btn) {
  padding: 12px;
  border-radius: 14px;
  border: none;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  background: #facc15;
  color: #020617;
  transition: 0.3s;
}

.add-category-container button:not(.close-btn):hover {
  background: #fde047;
}

.add-category-container button:not(.close-btn):disabled {
  background: #475569;
  cursor: not-allowed;
}

/* Close (X) button */
.close-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  border: none;
  background: transparent;
  padding: 6px;
  width: 36px;
  height: 36px;
  color: #94a3b8;
  font-size: 20px;
  font-weight: 700;
  cursor: pointer;
  line-height: 1;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s ease, transform 0.2s ease;
}

.close-btn:hover {
  color: #facc15;
  transform: rotate(90deg);
}
`, "",{"version":3,"sources":["webpack://./src/pages/Masters/category/AddCategory/AddCategory.css"],"names":[],"mappings":"AAAA,cAAc;AACd;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,qDAAqD;EACrD,mBAAmB;EACnB,0CAA0C;EAC1C,cAAc;EACd,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,WAAW;AACX;;EAEE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,wBAAwB;AAC1B","sourcesContent":["/* Container */\n.add-category-container {\n  max-width: 520px;\n  margin: 40px auto;\n  padding: 30px;\n  background: linear-gradient(180deg, #0f172a, #020617);\n  border-radius: 20px;\n  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.6);\n  color: #ffffff;\n  position: relative;\n}\n\n/* Heading */\n.add-category-container h2 {\n  text-align: center;\n  margin-bottom: 25px;\n  font-size: 22px;\n  font-weight: 600;\n}\n\n/* Form */\n.add-category-container form {\n  display: flex;\n  flex-direction: column;\n}\n\n/* Inputs */\n.add-category-container input[type=\"text\"],\n.add-category-container input[type=\"file\"] {\n  width: 100%;\n  padding: 12px 14px;\n  margin-bottom: 18px;\n  border-radius: 12px;\n  border: 1px solid #1e293b;\n  outline: none;\n  transition: 0.3s;\n}\n\n.add-category-container input::placeholder {\n  color: #64748b;\n}\n\n.add-category-container input:focus {\n  border-color: #facc15;\n  box-shadow: 0 0 0 2px rgba(250, 204, 21, 0.2);\n}\n\n/* Image Upload Box */\n.image-upload-box {\n  position: relative;\n  width: 100%;\n  height: 180px;\n  border: 2px dashed #334155;\n  border-radius: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  margin-bottom: 20px;\n  background: #020617;\n  transition: 0.3s;\n  overflow: hidden;\n}\n\n.image-upload-box:hover {\n  border-color: #facc15;\n  background: #0f172a;\n}\n\n.image-upload-box span {\n  color: #94a3b8;\n  font-size: 14px;\n}\n\n.image-upload-box input[type=\"file\"] {\n  position: absolute;\n  inset: 0;\n  opacity: 0;\n  cursor: pointer;\n}\n\n/* Preview Image */\n.preview-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 14px;\n}\n\n/* Button */\n.add-category-container button:not(.close-btn) {\n  padding: 12px;\n  border-radius: 14px;\n  border: none;\n  font-weight: 600;\n  font-size: 14px;\n  cursor: pointer;\n  background: #facc15;\n  color: #020617;\n  transition: 0.3s;\n}\n\n.add-category-container button:not(.close-btn):hover {\n  background: #fde047;\n}\n\n.add-category-container button:not(.close-btn):disabled {\n  background: #475569;\n  cursor: not-allowed;\n}\n\n/* Close (X) button */\n.close-btn {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  border: none;\n  background: transparent;\n  padding: 6px;\n  width: 36px;\n  height: 36px;\n  color: #94a3b8;\n  font-size: 20px;\n  font-weight: 700;\n  cursor: pointer;\n  line-height: 1;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: color 0.2s ease, transform 0.2s ease;\n}\n\n.close-btn:hover {\n  color: #facc15;\n  transform: rotate(90deg);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
